<ng-container *ngIf="customerLanding$ | async; let customerLanding">
    <app-guest-mode-header
        (onOpenSearch)="openSearch = true"
        (onLogin)="updateAccessMode('login'); openLogin(customerLanding)"
    ></app-guest-mode-header>
    <div class="onBoarding-wrapper" *ngIf="!openSearch">
        <div
            class="top-part-wrapper guest-mode"
            [ngStyle]="{
                'background-image':
                    'url(' + (customerLanding.background_url ?? 'assets/images/dashboard-backgroud-min.jpg') + ')'
            }"
        >
            <div class="layer"></div>
            <div fxLayoutAlign="center center" fxLayout="column" class="top-part">
                <img
                    [src]="customerLanding.logotype_url ?? 'assets/images/klickdata-logo.png'"
                    [alt]="customerLanding.title"
                />
                <div fxLayoutAlign="start center" class="btns-wrapper" fxLayout="row">
                    <button class="noSignUp" mat-button (click)="updateAccessMode('login'); openLogin(customerLanding)">
                        <span i18n>Login</span>
                    </button>
                    <button
                        *ngIf="customerLanding.enable_anonymous_register"
                        class="signupBtn"
                        mat-button
                        (click)="updateAccessMode('signup'); openLogin(customerLanding)"
                    >
                        <span i18n>Signup</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="openSearch">
        <div class="search-part-wrapper" style="background-image: url('assets/images/search-background-min.jpg')">
            <div class="layer-search"></div>
            <div fxLayoutAlign="center center" class="middle-part" fxLayout.lt-md="column">
                <div
                    class="search-box relative"
                    fxFlex="1 1 40%"
                    fxFlex.lt-md="1 1 95%"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <app-search class="search-onoarding" [guestMode]="true"></app-search>
                    <button
                        class="cancel-search"
                        mat-icon-button
                        (click)="onCancelSearch()"
                        matTooltip="Cancel Search"
                        i18n-matTooltip
                    >
                        <mat-icon>cancel</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="search-result onboarding">
            <router-outlet></router-outlet>
        </div>
    </ng-container>
    <div class="p-1 bottom-part" fxLayoutAlign="space-between start" fxLayout="row">
        <div class="sections" fxLayout="row">
            <app-guest-mode-sections selectedView="grid"></app-guest-mode-sections>
        </div>
    </div>
    <app-guest-onboarding-footer [landing]="customerLanding" fxFlex="1 1 auto"></app-guest-onboarding-footer>

    <!-- SectionService > line 214
 AuthService > Line 314
 AuthService > Line779  -->
</ng-container>
